/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
} from '@angular/core';
import {MdDatepicker} from './datepicker';
import {MdDatepickerIntl} from './datepicker-intl';
import {coerceBooleanProperty} from '@angular/cdk/coercion';
import {Subscription} from 'rxjs/Subscription';
import {merge} from 'rxjs/observable/merge';
import {of as observableOf} from 'rxjs/observable/of';
import {MATERIAL_COMPATIBILITY_MODE} from '@angular/material/core';
export class MdDatepickerToggle<D> implements OnChanges, OnDestroy {
private _stateChanges = Subscription.EMPTY;
/**
 * Datepicker instance that the button will toggle.
 */
datepicker: MdDatepicker<D>;
/**
 * Whether the toggle button is disabled.
 * @return {?}
 */
get disabled() {
    return this._disabled === undefined ? this.datepicker.disabled : this._disabled;
  }
/**
 * @param {?} value
 * @return {?}
 */
set disabled(value) {
    this._disabled = coerceBooleanProperty(value);
  }
private _disabled: boolean;
/**
 * @param {?} _intl
 * @param {?} _changeDetectorRef
 */
constructor(
public _intl: MdDatepickerIntl,
private _changeDetectorRef: ChangeDetectorRef) {}
/**
 * @param {?} changes
 * @return {?}
 */
ngOnChanges(changes: SimpleChanges) {
    if (changes.datepicker) {
      const /** @type {?} */ datepicker: MdDatepicker<D> = changes.datepicker.currentValue;
      const /** @type {?} */ datepickerDisabled = datepicker ? datepicker._disabledChange : observableOf();
      const /** @type {?} */ inputDisabled = datepicker && datepicker._datepickerInput ?
        datepicker._datepickerInput._disabledChange :
        observableOf();

      this._stateChanges.unsubscribe();
      this._stateChanges = merge(this._intl.changes, datepickerDisabled, inputDisabled)
        .subscribe(() => this._changeDetectorRef.markForCheck());
    }
  }
/**
 * @return {?}
 */
ngOnDestroy() {
    this._stateChanges.unsubscribe();
  }
/**
 * @param {?} event
 * @return {?}
 */
_open(event: Event): void {
    if (this.datepicker && !this.disabled) {
      this.datepicker.open();
      event.stopPropagation();
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'md-datepicker-toggle, mat-datepicker-toggle',
  templateUrl: 'datepicker-toggle.html',
  host: {
    'class': 'mat-datepicker-toggle',
  },
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [{provide: MATERIAL_COMPATIBILITY_MODE, useValue: true}],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdDatepickerIntl, },
{type: ChangeDetectorRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'datepicker': [{ type: Input, args: ['for', ] },],
'disabled': [{ type: Input },],
};
}

function MdDatepickerToggle_tsickle_Closure_declarations() {
/** @type {?} */
MdDatepickerToggle.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdDatepickerToggle.ctorParameters;
/** @type {?} */
MdDatepickerToggle.propDecorators;
/** @type {?} */
MdDatepickerToggle.prototype._stateChanges;
/**
 * Datepicker instance that the button will toggle.
 * @type {?}
 */
MdDatepickerToggle.prototype.datepicker;
/** @type {?} */
MdDatepickerToggle.prototype._disabled;
/** @type {?} */
MdDatepickerToggle.prototype._intl;
/** @type {?} */
MdDatepickerToggle.prototype._changeDetectorRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
